import { action, computed, observable, makeAutoObservable } from 'mobx';
import { ModelsState } from 'src_common/common/websocket2/ModelsState';
import { Resource } from 'src_common/common/mobx-utils/Resource';
import { RouterBackoffice } from 'src/AppState/RouterBackoffice';
import { SportModel } from 'src_common/common/websocket2/models/SportModel/SportModel';
import { SdkStaff, SportsListType } from 'src/AppState/sdk/staff';

export class EventsTabState {
    @observable private readonly allSports: Resource<SportsListType>;

    constructor(
        readonly websocketV2: ModelsState,
        readonly routerBackoffice: RouterBackoffice,
        readonly sdkStaff: SdkStaff
    ) {
        this.allSports = new Resource(async (): Promise<SportsListType> => await sdkStaff.getAllSports());
        makeAutoObservable(this);
    }

    @computed get sportList(): SportsListType {
        const allSports = this.allSports.get();
        if (allSports.type === 'ready') {
            return allSports.value;
        }
        return [];
    }

    @computed get sports(): Array<SportModel> {
        const list: Array<SportModel> = [];
        for (const sport of this.sportList) {
            const sportModel = this.websocketV2.getSport(sport.id);
            if (sportModel !== null) {
                list.push(sportModel);
            }
        }
        const sortedSports = list.sort((a, b) => a.displayOrder - b.displayOrder);

        return sortedSports.reverse();
    }

    @computed get currentActiveTab(): string {
        const sportRoute = this.routerBackoffice.getParametersString('customers', 'sport');
        const firstSport = this.sports[0]?.id ?? '';

        if (sportRoute === null) {
            return firstSport;
        }
        return sportRoute;
    }

    @action handleTabClick = (tabId: string) => {
        return (e: React.MouseEvent<HTMLButtonElement>): void => {
            e.preventDefault();
            this.onChangeRoute(tabId);
        };
    };

    @action private onChangeRoute = (sportId: string): void => {
        this.routerBackoffice.setParamInNamespace('customers', 'sport', sportId);

        this.routerBackoffice.removeParamInNamespace('customers', 'competition');
        this.routerBackoffice.removeParamInNamespace('customers', 'event');
        this.routerBackoffice.removeParamInNamespace('customers', 'search');
        this.routerBackoffice.removeParamInNamespace('customers', 'region');
        this.routerBackoffice.removeParamInNamespace('customers', 'race-type');
        this.routerBackoffice.removeParamInNamespace('customers', 'time-filter');
    };

    @computed get isLoadingActive(): boolean {
        return this.sports.length === 0;
    }
}
